import React, { useState, useEffect, useRef, Fragment } from "react";
import Modal from "react-bootstrap/Modal";
import { useReactToPrint } from "react-to-print";
import toast, { Toaster } from "react-hot-toast";
import { getDebitNoteList, getDebitNoteDetail, getApprovedDebitNotes, getDebitNotesHistory } from "../../../services/index";
import ViewPdf from "../../Common/ViewPdf";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { Link, useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import CreateDebitNote from "./CreateDebitNote";
import { getFormattedNumber } from "../../utils/textUtils";
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import dayjs from "dayjs";

const DebitNoteView = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [keys, setKeys] = useState("");
  const [values, setValues] = useState("");
  const [billNo, setBillNo] = useState("");
  const [debitNoteId, setDebitNoteId] = useState("");
  const [debitDetails, setDebitDetails] = useState("");
  const [debitNoteList, setDebitNoteList] = useState([]);
  const [debitNoteList2, setDebitNoteList2] = useState([]);
  const [hsnKey, setHsnKey] = useState("");
  const [hsnVal1, setHsnVal1] = useState("");
  const [hsnVal2, setHsnVal2] = useState("");
  const [taxType, setTaxType] = useState("");
  const [orgDetail, setOrgDetail] = useState("");
  const [logData, setLogData] = useState({});
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const componentRef = useRef();
  const [DebitNotesListDetails, setDebitNotesListDetails] = useState(null);
  const [index, setIndex] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [tabIndex, setTabIndex] = useState(0);
  const [logHistory, setLogHistory] = useState([]);

  let org = JSON.parse(localStorage.getItem("orgDetail"));

  useEffect(() => {
    setOrgDetail(org);
  }, []);

  const getAllDebitNotes = () => {
    let list_data = {
      page: index,
      size: 15,
      search: filterText,
    };
    getDebitNoteList(list_data).then((res) => {
      if (res.errorCode === 0) {
        if (index === 0) {
          setDebitNoteList(res.responsePacket.data);
          setDebitNoteList2(res.responsePacket.data);
        } else {
          const setDebitNotesClone = [
            ...debitNoteList,
            ...res.responsePacket.data,
          ];
          setDebitNoteList(setDebitNotesClone);
          setDebitNoteList2(setDebitNotesClone);
        }
        setIndex(index + 1);
        setDebitNotesListDetails({
          recordsFiltered: res.responsePacket.recordsFiltered,
          recordsTotal: res.responsePacket.recordsTotal,
          total: res.responsePacket.total,
        });
      } else {
        toast(res.message);
      }
    }).catch(err => {
      console.error("Error in getDebitNoteList:", err);
    });
  };

  useEffect(() => {
    if (debitNoteId) {
      getDebitDetails1(debitNoteId);
    }
  }, [debitNoteId]);

  useEffect(() => {
    if (debitNoteList.length > 0 && !debitNoteId) {
      setDebitNoteId(debitNoteList[0].recordId);
      setBillNo(debitNoteList[0].billNo);
    }
  }, [debitNoteList]);

  useEffect(() => {
    getAllDebitNotes();
  }, [filterText]);

  const getDebitDetails1 = (id) => {
    getDebitNoteDetail(id).then((res) => {
      if (res.errorCode === 0) {
        let ddd = res.responsePacket;
        let d = res.responsePacket.debitNoteItemsList || res.responsePacket.purchaseOrderItemBeans || [];

        var tot = JSON.parse(JSON.stringify(ddd.totalAmount));
        let tot1 = 0;
        let netTax = 0;
        let disTax = 0;
        let disPercent = 0;
        let disAmount = 0;
        let disSubtotal = 0;
        let subtot = res.responsePacket.subTotalAmount;
        let calculatedTotal = 0;

        let org = JSON.parse(localStorage.getItem("orgDetail"));
        setOrgDetail(org);
        let calculatedTaxType = "inter";
        let vendorGst = res.responsePacket.vendorGst || res.responsePacket.vendorGstNumber;
        if (vendorGst && org?.gstNumber) {
          let gst12cust = vendorGst.substring(0, 2);
          let gst12org = org.gstNumber.substring(0, 2);
          if (gst12cust === gst12org) {
            calculatedTaxType = "intra";
          }
        }
        setTaxType(calculatedTaxType);

        if (subtot === undefined || subtot === null || subtot === 0) {
          subtot = 0;
          d.forEach((item) => {
            subtot += item.amount || 0;
          });
        }

        // recalculate totalAmount if it's not provided or 0
        if (!tot) {
          let calculatedTax = 0;
          d.forEach((item) => {
            const taxRate = parseFloat(item.taxes?.rate) || 0;
            calculatedTax += (item.amount * taxRate) / 100;
          });
          ddd.totalAmount = subtot + calculatedTax;
          tot = ddd.totalAmount;
        }

        ddd.shipAdd = ddd.vendorAddress;
        if (ddd.discountTypeEnum === "Percentage") {
          let dis = 0.01 * ddd.discountValue * subtot;
          disPercent = ddd.discountPercent = ddd.discountValue;
          disAmount = ddd.discountAmount = dis;
          tot1 = tot - dis;
          ddd.discountSubTotal = subtot - ddd.discountAmount;
        } else if (ddd.discountTypeEnum === "Amount") {
          let dis = 0;
          if (subtot > 0) dis = (100 * ddd.discountValue) / subtot;
          disPercent = ddd.discountPercent = dis;
          disAmount = ddd.discountAmount = ddd.discountValue;
          tot1 = tot - ddd.discountValue;
          ddd.discountSubTotal = subtot - ddd.discountAmount;
        } else {
          tot1 = JSON.parse(JSON.stringify(ddd.totalAmount));
          ddd.discountSubTotal = subtot;
          ddd.discountPercent = 0;
          ddd.discountAmount = 0;
        }

        d.forEach((a) => {
          const tax = a.taxes || a.taxBean;
          if (tax) {
            // Replicate CreditNoteView's newTax logic: taxType + rate.toString()
            const type = tax.taxType || (tax.title ? tax.title.split(' ')[0] : (calculatedTaxType === 'intra' ? 'GST' : 'IGST'));
            tax.newTax = type + (tax.rate || 0).toString();
            tax.disAmount = tax.amount;
            netTax += tax.amount;
            disTax += tax.disAmount;
          }
          a.disItemAmount = a.amount - a.amount * (disPercent || 0) * 0.01;
          disSubtotal += a.disItemAmount;
        });

        let obj = {};
        for (let i = 0; i < d.length; i++) {
          const tax = d[i].taxes || d[i].taxBean;
          if (tax) {
            if (calculatedTaxType === "intra") {
              let gstKey = "GST" + tax.rate;
              obj[gstKey] = (obj[gstKey] || 0) + tax.disAmount;
            } else {
              let igstKey = "IGST" + tax.rate;
              if (obj[igstKey]) {
                obj[igstKey] += tax.disAmount;
              } else {
                obj[igstKey] = tax.disAmount;
              }
            }
          }
        }

        setKeys(Object.keys(obj));
        setValues(Object.values(obj));

        let arr = [];
        Object.keys(obj).forEach((a, i) => {
          Object.values(obj).forEach((b, j) => {
            if (i === j) {
              arr.push({ tax: a, value: b });
            }
          });
        });

        let z = JSON.parse(JSON.stringify(d));

        z.forEach((a) => {
          const tax = a.taxes || a.taxBean;
          if (tax) {
            a.newHsn = (a.hsnSac ? a.hsnSac.toString() : "") + "_" + tax.newTax;
          }
        });

        let obj2 = {};
        for (let i = 0; i < z.length; i++) {
          const tax = z[i].taxes || z[i].taxBean;
          if (tax) {
            if (obj2[z[i].newHsn]) {
              obj2[z[i].newHsn] += tax.disAmount;
            } else {
              obj2[z[i].newHsn] = tax.disAmount;
            }
          }
        }

        let obj3 = {};
        for (let i = 0; i < z.length; i++) {
          if (obj3[z[i].newHsn]) {
            obj3[z[i].newHsn] += z[i].disItemAmount;
          } else {
            obj3[z[i].newHsn] = z[i].disItemAmount;
          }
        }

        setHsnKey(Object.keys(obj2));
        setHsnVal1(Object.values(obj2));
        setHsnVal2(Object.values(obj3));

        let t2 = ddd.totalAmount.toFixed(2).toString()?.split(".")[1];
        if (t2 > 49) {
          ddd.totalAmount += 1;
          let a = 100 - t2;
          ddd.rounding = "+0." + a;
        } else {
          ddd.rounding = "-0." + t2;
        }

        ddd.netTax = netTax;
        ddd.disTax = disTax;

        ddd.taxDetail = arr;

        let localDate = new Date(res?.responsePacket?.billDate)
          .toISOString()
          .replace(/T.*/, "")
          .split("-")
          .reverse()
          .join("-");

        if (res?.responsePacket?.debitNoteIssueDate) {
          let localDate2 = new Date(res?.responsePacket?.debitNoteIssueDate)
            .toISOString()
            .replace(/T.*/, "")
            .split("-")
            .reverse()
            .join("-");
          res.responsePacket.debitNoteIssueDate = localDate2;
        } else {
          res.responsePacket.debitNoteIssueDate = localDate;
        }

        res.responsePacket.billDate = localDate;

        if (res?.responsePacket?.invoiceDate) {
          try {
            const invDate = new Date(res.responsePacket.invoiceDate)
              .toISOString()
              .replace(/T.*/, "")
              .split("-")
              .reverse()
              .join("-");
            res.responsePacket.invoiceDate = invDate;
          } catch (e) {
            res.responsePacket.invoiceDate = undefined;
          }
        }

        setDebitDetails(res.responsePacket);
      } else {
        toast(res.message);
      }
    }).catch(err => {
      console.error("Error in getDebitNoteDetail:", err);
      toast.error("Error fetching Debit Note details from server.");
    });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: debitDetails?.billNo,
    pageStyle: "print",
  });

  useEffect(() => {
    if (tabIndex === 1) {
      if (debitDetails.debitNoteNo) {
        getDebitNotesHistory(debitDetails.debitNoteNo).then((res) => {
          if (res.errorCode === 0) {
            const resData = res.responsePacket;
            setLogHistory(resData);
          } else {
            toast(res.message);
          }
        }).catch((error) => {
          toast.error("An error occurred while fetching the log history.");
          console.error(error);
        });
      }
    }
  }, [tabIndex, debitDetails.debitNoteNo]);

  const handleApproved = () => {
    const debitNoteUuid = debitDetails.recordId;
    const billNo = debitDetails?.billNo;
    const billId = debitDetails?.billUuid || debitDetails?.billId;
    const data = {
      debitNoteUuid,
      billId,
      billNo,
      billUuid: billId,
      vendorUuid: debitDetails?.vendorUuid,
      vendorName: debitDetails?.vendorName,
      debitNoteNo: debitDetails?.debitNoteNo,
      pricelistId: debitDetails?.pricelistId,
      pricelistTitle: debitDetails?.pricelistTitle,
      totalAmount: debitDetails?.totalAmount,
      subTotal: debitDetails?.subTotal,
      taxAmount: debitDetails?.taxAmount,
      discountAmount: debitDetails?.discountAmount,
      isDebitNoteGenerated: debitDetails?.isDebitNoteGenerated,
      recordId: debitDetails?.recordId,
      active: debitDetails?.active,
      deleted: debitDetails?.deleted,
      debitNoteNoAlt: debitDetails?.debitNoteNoAlt,
      purchaseOrderItemBeans: debitDetails?.purchaseOrderItemBeans?.map((item) => ({
        packUnit: item.packUnitTitle || item.unit,
        itemUuid: item.itemUuid,
        itemTitle: item.itemTitle,
        hsnSac: item.hsnSac,
        taxes: item.taxes,
        rate: item.rate,
        amount: item.amount,
        discountAmount: item.discountAmount,
        quantity: item.quantity,
        debitNoteItemTypeEnum: item.debitNoteItemTypeEnum,
        unit: item.unit,
        unitId: item.unitId,
        packUnitId: item.packUnitId,
        packUnitUuid: item.packUnitUuid,
      })),
    };

    getApprovedDebitNotes(data).then((res) => {
      if (res.errorCode === 0) {
        toast.success(res.message);
        setDebitDetails((prevDebitDetails) => ({
          ...prevDebitDetails,
          isDebitNoteGenerated: true,
        }));
      } else {
        toast.error(res.message);
      }
    }).catch((error) => {
      toast.error("An error occurred while approved the debit note.");
      console.error(error);
    });
  };

  let time;
  const handleSearch = (e) => {
    const { value } = e.target;
    clearTimeout(time);
    time = setTimeout(() => {
      setIndex(0);
      setFilterText(value);
    }, 500);
  };


  return (
    <>
      {showCreateModal && (
        <CreateDebitNote
          show={showCreateModal}
          onHide={() => {
            setShowCreateModal(false);
            setDebitNoteList([]);
            setDebitNoteList2([]);
            setIndex(0);
            let list_data = { page: 0, size: 15, search: filterText };
            getDebitNoteList(list_data).then((res) => {
              if (res.errorCode === 0) {
                setDebitNoteList(res.responsePacket.data);
                setDebitNoteList2(res.responsePacket.data);
                setIndex(1);
                setDebitNotesListDetails({
                  recordsFiltered: res.responsePacket.recordsFiltered,
                  recordsTotal: res.responsePacket.recordsTotal,
                  total: res.responsePacket.total,
                });
              }
            });
          }}
        />
      )}
      {debitDetails && showEditModal && (
        <CreateDebitNote
          key={`edit_${debitDetails.recordId}`}
          show={showEditModal}
          onHide={() => {
            setShowEditModal(false);
            getDebitDetails1(debitNoteId);
            setDebitNoteList([]);
            setDebitNoteList2([]);
            setIndex(0);
            let list_data = { page: 0, size: 15, search: filterText };
            getDebitNoteList(list_data).then((res) => {
              if (res.errorCode === 0) {
                setDebitNoteList(res.responsePacket.data);
                setDebitNoteList2(res.responsePacket.data);
                setIndex(1);
                setDebitNotesListDetails({
                  recordsFiltered: res.responsePacket.recordsFiltered,
                  recordsTotal: res.responsePacket.recordsTotal,
                  total: res.responsePacket.total,
                });
              }
            });
          }}
          billRecordId={debitDetails.billUuid}
          billNo={debitDetails.billNo}
          isEdit={true}
          exData={debitDetails}
        />
      )}
      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          <table>
            {logData.length === 0 ? (
              "No Changes Found"
            ) : (
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Changes</th>
                </tr>
              </thead>
            )}
            {logData.length >= 1 && (
              <tbody>
                {logData?.map((history, i) => {
                  return (
                    <Fragment key={i}>
                      <tr>
                        <td style={{ verticalAlign: "top" }}>
                          {history?.transactionDate?.substring(0, 10)}
                          :&nbsp;&nbsp;
                        </td>

                        <td>
                          <div style={{ whiteSpace: "pre-wrap" }}>
                            {history?.message}
                          </div>
                        </td>
                      </tr>
                      <hr />
                    </Fragment>
                  );
                })}
              </tbody>
            )}
          </table>
        </Modal.Body>
      </Modal>
      <div
        className="list-column column d-print-none"
        style={{ width: "330px" }}
      >
        <div className="fill list-header topgrad d-print-none">
          <div className="list-filter pt-3 d-flex align-items-center">
            <button
              className="newListBtn"
              onClick={() => setShowCreateModal(true)}
            >
              <AddIcon />
              New
            </button>
            <div className="input-group paginationSearchInput listSearch">
              <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon1">
                  <SearchRoundedIcon />
                </span>
              </div>
              <input
                autoComplete="off"
                className="ember-text-field ember-view form-control"
                type="text"
                placeholder="Search..."
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className="scroll-y fill body scrollbox list-body">
          <div className="table-responsive overflow-initial ">
            <table
              id="ember7912"
              className="table zi-table ember-view header-fixed"
            >
              {debitNoteList &&
                (debitNoteList.length > 0 ? (
                  <tbody>
                    {debitNoteList.map((d, i) => (
                      <tr
                        key={i}
                        className={`listTr ${debitNoteId === d.recordId ? "activeRecord" : ""}`}
                        onClick={() => {
                          setBillNo(d.billNo);
                          setDebitNoteId(d.recordId);
                        }}
                      >
                        <td>
                          <Link
                            className={`${debitNoteId === d.recordId
                              ? "text-primary"
                              : "text-grey"
                              }`}
                          >
                            <span className="titleTr">{d.vendorTitle}</span>
                            <span className="d-flex justify-content-between">
                              <span>{d.debitNoteNoAlt}</span>
                              <span>₹ {getFormattedNumber(d.totalAmount)}</span>
                              <span>{d.billNo}</span>
                            </span>
                          </Link>
                        </td>
                      </tr>
                    ))}
                    {DebitNotesListDetails &&
                      DebitNotesListDetails.recordsTotal >
                      debitNoteList.length && (
                        <tr>
                          <td className="pt-3 text-center">
                            <button
                              className="btn mx-auto newListBtn"
                              onClick={getAllDebitNotes}
                            >
                              Load More
                            </button>
                          </td>
                        </tr>
                      )}
                  </tbody>
                ) : (
                  <div className="my-3 text-black text-center">
                    No Data Available!
                  </div>
                ))}
            </table>
          </div>
        </div>
      </div>

      <div className="column content-column" style={{ left: "330px" }}>
        <div className=" header d-flex align-items-center p-4 justify-content-between">
          <div className="listTopHeading">
            <div className="btn-toolbar over-flow text-muted font-xlarge pb-0"> {debitDetails?.debitNoteNoAlt}&nbsp;&nbsp;
              <div
                className="cursor-pointer text-primary font-size-15"
                onClick={() => {
                  const billId = debitDetails?.billUuid || debitDetails?.billId;
                  if (billId) {
                    navigate(`/bills/${billId}`);
                  } else {
                    toast.error("Bill ID not found.");
                  }
                }}
              >
                ( {debitDetails?.billNo} )
              </div>
            </div>
          </div>

          <div className="btn-toolbar d-flex justify-content-end align-items-center">
            {!debitDetails.isDebitNoteGenerated && (
              <div className="btn-group pr-2">
                <button
                  className="tooltip-container ember-view btn btn-primary print-btn mr-0"
                  onClick={() => setShowEditModal(true)}
                >
                  <EditIcon />
                </button>
              </div>
            )}
            <div className="btn-group pr-2">
              <button
                className="tooltip-container ember-view btn btn-primary print-btn mr-0"
                onClick={handlePrint}
              >
                <LocalPrintshopOutlinedIcon />
              </button>
            </div>
            <div className="btn-group pr-2">
              <button
                className="tooltip-container ember-view btn btn-primary print-btn mr-0 me-2"
                onClick={handleApproved}
                disabled={debitDetails.isDebitNoteGenerated}
                style={{
                  backgroundColor: debitDetails.isDebitNoteGenerated ? '#17d7aa' : '',
                  border: debitDetails.isDebitNoteGenerated ? 'none' : '',
                  color: debitDetails.isDebitNoteGenerated ? 'white' : '',
                  cursor: debitDetails.isDebitNoteGenerated ? 'not-allowed' : 'pointer'
                }}
              >
                <ThumbUpAltIcon
                  style={{
                    color: debitDetails.isDebitNoteGenerated ? 'white' : '',
                    marginRight: 5
                  }}
                />
                <span style={{
                  color: debitDetails.isDebitNoteGenerated ? 'white' : ''
                }}>
                  Approve
                </span>
              </button>
            </div>
          </div>
        </div>

        <Tabs selectedIndex={tabIndex}
          onSelect={(index) => setTabIndex(index)}
          className="upperTabs">
          <TabList>
            <Tab>Primary Details</Tab>
            <Tab>Log History</Tab>
          </TabList>
          <TabPanel>
            {debitDetails && debitDetails && orgDetail && orgDetail ? (
              <ViewPdf
                handlePrint={handlePrint}
                orderDetail={debitDetails}
                orgDetail={orgDetail}
                itemList={debitDetails.debitNoteItemsList || debitDetails.purchaseOrderItemBeans}
                taxType={taxType}
                pdfType={"debit"}
                componentRef={componentRef}
                keys={keys}
                values={values}
                hsnKey={hsnKey}
                hsnVal1={hsnVal1}
                hsnVal2={hsnVal2}
              />
            ) : (
              <></>
            )}
          </TabPanel>
          <TabPanel>
            <div className="ember-view scroll-y noscroll-x fill body scrollbox">
              <table className="customTable">
                {logHistory && logHistory.length === 0 ? (
                  "No Changes Found"
                ) : (
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Changes</th>
                    </tr>
                  </thead>
                )}
                {logHistory && (
                  <tbody>
                    {logHistory.length >= 1 &&
                      logHistory?.map((history, i) => (
                        <tr key={i}>
                          <td style={{ verticalAlign: "top", width: "80px" }}>
                            {history?.transactionDate?.substring(0, 10)}
                            :&nbsp;&nbsp;
                            <br />
                            Time:
                            {history?.transactionDate
                              ?.split("T")[1]
                              ?.substring(0, 5)}
                          </td>
                          <td>
                            <div style={{ whiteSpace: "pre-wrap" }}>
                              {history?.message}
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                )}
              </table>
            </div>
          </TabPanel>
        </Tabs>
      </div>
      <Toaster />
    </>
  );
};

export default DebitNoteView;
